import { ReactComponent as LiquityWithText } from '../resources/liquity-with-text.svg'

function LiquityHeader() {
  return (
    <div style={{ textAlign: 'center' }}>
      <LiquityWithText style={{ maxWidth: 180 }} />
    </div>
  )
}

export default LiquityHeader
